import { combineReducers } from 'redux';

import { IEvent } from '@travelnest/typewriter';

import { Actions, ActionTypes } from './actions';

const receiveEvents = (current: IEvent[], events: IEvent[]) => {
	const ids = events.map((e) => e.id);
	const next = current.filter((e) => !ids.includes(e.id));
	return next.concat(events);
};

export const byPropertyId = (state = {} as { [id: string]: IEvent[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.EVENT_DELETE_RECEIVE:
			const deleteExisting = state[action.payload.id] || [];
			const deleteUpdated = deleteExisting.filter((e) => e.id !== action.payload.events.id);
			return { ...state, [action.payload.id]: deleteUpdated };
		case ActionTypes.EVENT_UPDATE_RECEIVE:
			const updated = receiveEvents(state[action.payload.id] || [], [action.payload.events]);
			return { ...state, [action.payload.id]: updated };
		case ActionTypes.EVENT_CREATE_RECEIVE:
		case ActionTypes.BLOCK_BY_DATE_RANGE_CREATE_RECEIVE:
		case ActionTypes.AVAILABILITY_GET_EVENTS_BY_ID_RECEIVE:
		case ActionTypes.EVENT_WITH_BOOKING_CREATE_RECEIVE:
			const next = receiveEvents(state[action.payload.id] || [], action.payload.events);
			return { ...state, [action.payload.id]: next };
		case ActionTypes.AVAILABILITY_GET_EVENTS_BY_ID_FAILURE:
			if (action.payload.error.data.status === 404) {
				return { ...state, [action.payload.id]: [] as IEvent[] };
			}
			return state;
		default:
			return state;
	}
};

export const creating = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.EVENT_CREATE_REQUEST:
		case ActionTypes.BLOCK_BY_DATE_RANGE_CREATE_RECEIVE:
		case ActionTypes.EVENT_WITH_BOOKING_CREATE_REQUEST:
			return true;
		case ActionTypes.EVENT_CREATE_RECEIVE:
		case ActionTypes.EVENT_CREATE_FAILURE:
		case ActionTypes.EVENT_WITH_BOOKING_CREATE_RECEIVE:
		case ActionTypes.EVENT_WITH_BOOKING_CREATE_FAILURE:
			return false;
		default:
			return state;
	}
};

interface IAvailabilityState {
	byPropertyId: ReturnType<typeof byPropertyId>;
	creating: ReturnType<typeof creating>;
}

export default combineReducers<IAvailabilityState>({
	byPropertyId,
	creating
});
